<template>
  <div class="overview-cases-container" v-if="list.length">
    <!-- search -->
    <div class="search-wrap">
      <el-input placeholder="Search for weapon skin name" prefix-icon="el-icon-search" v-model="searchWeaponName"
        clearable @clear="updateWeaponList" @keyup.native.enter="updateWeaponList"
        @keyup.native.backspace="handlerBackspace">
      </el-input>
    </div>
    <!-- cases list -->
    <div class="overview-list">
      <div class="overview-item" v-for="item in viewList" :key="item.id">
        <CaseHeader :caseInfo="item" />
        <WeaponGrid style="margin-top: 32px;" :list="item.weapons" />
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import CaseHeader from "./components/caseHeader";
import WeaponGrid from "./components/weaponGrid";
export default {
  mixins: [responsiveMixin],
  components: { CaseHeader, WeaponGrid },
  data() {
    return {
      searchWeaponName: "",
      viewList: []
    };
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    updateWeaponList() {
      const val = this.searchWeaponName;
      if (val.trim() === "") {
        this.viewList = this.list;
      } else {
        this.viewList = this.list.map(item => {
          return {
            ...item,
            weapons: item.weapons.filter(weapon => {
              if (weapon.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
                return weapon;
              }
            })
          }
        })
      }
    },
    handlerBackspace() {
      const val = this.searchWeaponName;
      if (val.trim() === "") {
        this.viewList = this.list;
      }
    }
  },
  watch: {
    list: {
      handler(newValue) {
        this.viewList = newValue;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
